const DEFAULT_TAB_PATH = "/dashboard";

/**
 * Buat state awal untuk workspace.
 * Setiap tab memiliki ID, path aktif, dan riwayat navigasi sendiri.
 */
export function createWorkspaceTab(path, label = path) {
  const initialPath = path || DEFAULT_TAB_PATH;

  return {
    id: createTabId(),
    path: initialPath,
    label,
    history: [initialPath],
    historyIndex: 0,
    closable: initialPath !== DEFAULT_TAB_PATH,
  };
}

function createTabId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return `workspace-tab-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}

/**
 * Catat navigasi internal pada satu tab tanpa mengubah riwayat tab lain.
 */
export function navigateWorkspaceTab(tab, nextPath, options = {}) {
  if (!tab || !nextPath) return tab;

  const currentPath = tab.history[tab.historyIndex] || tab.path;

  if (currentPath === nextPath) return tab;

  const history = options.replace
    ? tab.history.map((item, index) =>
        index === tab.historyIndex ? nextPath : item
      )
    : [
        ...tab.history.slice(0, tab.historyIndex + 1),
        nextPath,
      ];

  return {
    ...tab,
    path: nextPath,
    history,
    historyIndex: options.replace
      ? tab.historyIndex
      : history.length - 1,
  };
}

export function traverseWorkspaceTab(tab, direction) {
  if (!tab || !Number.isInteger(direction) || direction === 0) {
    return tab;
  }

  const nextIndex = Math.max(
    0,
    Math.min(tab.history.length - 1, tab.historyIndex + direction)
  );

  if (nextIndex === tab.historyIndex) return tab;

  return {
    ...tab,
    historyIndex: nextIndex,
    path: tab.history[nextIndex],
  };
}

export function removeWorkspaceTab(tabs, tabId) {
  return (tabs || []).filter(
    (tab) => tab.id !== tabId || !tab.closable
  );
}

/**
 * Ambil tab aktif berdasarkan ID, bukan berdasarkan URL.
 */
export function getWorkspaceTabById(tabs, tabId) {
  return (tabs || []).find((tab) => tab.id === tabId) || null;
}

/**
 * Perbarui lokasi sebuah tab tanpa mengubah state tab lainnya.
 */
export function updateWorkspaceTabPath(tabs, tabId, nextPath, options = {}) {
  if (!Array.isArray(tabs) || !tabId || !nextPath) return tabs;

  let changed = false;
  const updated = tabs.map((tab) => {
    if (tab.id !== tabId) return tab;

    const nextTab = navigateWorkspaceTab(tab, nextPath, options);
    if (nextTab !== tab) changed = true;
    return nextTab;
  });

  return changed ? updated : tabs;
}
